var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6550_25359)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.99 17.2099C9.12004 17.2099 6.79004 14.8799 6.79004 11.9899C6.79004 9.09992 9.12004 6.78992 11.99 6.78992C14.86 6.78992 17.21 9.11992 17.21 11.9899C17.21 14.8599 14.88 17.2099 11.99 17.2099ZM11.99 7.31992C9.42004 7.31992 7.31004 9.42992 7.31004 11.9999C7.31004 14.5699 9.42004 16.6799 11.99 16.6799C14.56 16.6799 16.67 14.5899 16.67 11.9999C16.67 9.40992 14.58 7.31992 11.99 7.31992Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9895 15.7999C11.6395 15.7999 11.6395 15.2699 11.9895 15.2699C13.7895 15.2699 15.2595 13.7999 15.2595 11.9999C15.2595 11.6499 15.7895 11.6499 15.7895 11.9999C15.7895 14.0899 14.0795 15.7999 11.9895 15.7999ZM8.45945 12.2599C8.30945 12.2599 8.18945 12.1399 8.18945 11.9899C8.18945 9.89994 9.89945 8.18994 11.9895 8.18994C12.3495 8.18994 12.3495 8.71994 11.9895 8.71994C10.1895 8.71994 8.71945 10.1899 8.71945 11.9899C8.71945 12.1399 8.60945 12.2599 8.44945 12.2599H8.45945Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9897 5.26994C11.8397 5.26994 11.7197 5.14994 11.7197 4.99994V0.889941C11.7197 0.539941 12.2497 0.539941 12.2497 0.889941V5.00994C12.2497 5.13994 12.1297 5.27994 11.9797 5.27994L11.9897 5.26994Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4997 6.20998C15.2897 6.20998 15.1697 5.97998 15.2597 5.80998L17.3097 2.24998C17.4997 1.93998 17.9497 2.20998 17.7797 2.51998L15.7297 6.07998C15.6797 6.15998 15.5997 6.20998 15.4997 6.20998Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0597 8.7699C17.7897 8.7699 17.6897 8.4099 17.9297 8.2799L21.4897 6.2099C21.7797 6.0399 22.0597 6.4999 21.7597 6.6799C21.3497 6.9199 18.2397 8.7699 18.0697 8.7699H18.0597Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.1098 12.26H18.9998C18.6498 12.26 18.6498 11.73 18.9998 11.73H23.1098C23.4698 11.73 23.4698 12.26 23.1098 12.26Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6202 17.83C21.4502 17.83 18.3402 15.98 17.9302 15.74C17.6202 15.57 17.8902 15.1 18.2002 15.27L21.7602 17.32C21.9902 17.47 21.8902 17.83 21.6302 17.83H21.6202Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5595 21.89C17.4695 21.89 17.3695 21.84 17.3195 21.76L15.2695 18.2C15.0995 17.89 15.5595 17.63 15.7395 17.93L17.7895 21.49C17.8995 21.66 17.7595 21.89 17.5595 21.89Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9897 23.3699C11.8397 23.3699 11.7197 23.2499 11.7197 23.0999V18.9899C11.7197 18.6399 12.2497 18.6399 12.2497 18.9899V23.0999C12.2497 23.2499 12.1297 23.3699 11.9797 23.3699H11.9897Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.44992 21.8899C6.23992 21.8899 6.11992 21.6599 6.20992 21.4899L8.27992 17.9299C8.44992 17.6199 8.90992 17.8899 8.72992 18.1999L6.67992 21.7599C6.62992 21.8399 6.54992 21.8899 6.44992 21.8899Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.38 17.83C2.11 17.83 2.01 17.47 2.25 17.32L5.81 15.27C6.12 15.1 6.38 15.56 6.08 15.74C5.67 15.98 2.56 17.83 2.39 17.83H2.38Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00969 12.26H0.879687C0.529687 12.26 0.529687 11.73 0.879687 11.73H4.99969C5.34969 11.73 5.34969 12.26 4.99969 12.26H5.00969Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.93949 8.76994C5.76949 8.76994 2.65949 6.91994 2.24949 6.67994C1.93949 6.50994 2.20949 6.03994 2.51949 6.20994L6.07949 8.27994C6.30949 8.40993 6.20949 8.76994 5.94949 8.76994H5.93949Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50014 6.20994C8.41014 6.20994 8.31014 6.15994 8.27014 6.07994L6.20014 2.51994C6.03014 2.20994 6.49014 1.94994 6.67014 2.24994L8.72014 5.80994C8.83014 5.97994 8.69014 6.20994 8.49014 6.20994H8.50014Z",
    fill: "black",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9896 8.72995C10.1896 8.72995 8.71957 10.1999 8.71957 11.9999C8.71957 12.1499 8.60957 12.2699 8.44957 12.2699C8.29957 12.2699 8.17957 12.1499 8.17957 11.9999C8.17957 9.90995 9.88957 8.19995 11.9796 8.19995C12.3396 8.19995 12.3396 8.72995 11.9796 8.72995H11.9896ZM11.9896 7.31995C9.41957 7.31995 7.30957 9.42995 7.30957 11.9999C7.30957 14.5699 9.41957 16.6799 11.9896 16.6799C14.5596 16.6799 16.6696 14.5899 16.6696 11.9999C16.6696 9.40995 14.5796 7.31995 11.9896 7.31995ZM11.9896 15.7999C11.6396 15.7999 11.6396 15.2699 11.9896 15.2699C13.7896 15.2699 15.2596 13.7999 15.2596 11.9999C15.2596 11.6499 15.7896 11.6499 15.7896 11.9999C15.7896 14.0899 14.0796 15.7999 11.9896 15.7999Z",
    fill: "#FFCC00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6550_25359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.14932cac0c59b477c88e338f6e079c30.svg";
export { ForwardRef as ReactComponent };